import { useRouter } from 'next/router';
import { COLLECTION_PAGE_CANONICALS } from 'layout/canonical/collectionPageCanonicals';
import { LOCALES } from 'localization/constants/configEnums';

export const useCanonical = () => {
  const { asPath, locale } = useRouter();
  const path = asPath?.split(/[#?]/)?.[0];
  const baseURL =
    locale === LOCALES.enUS ? 'https://www.goat.com' : `https://www.goat.com/${locale}`;
  // Default to self-referencing
  let canonical = `https://www.goat.com${path}`;

  if (locale !== LOCALES.enUS) {
    if (path === '/') {
      canonical = baseURL;
    } else {
      canonical = `${baseURL}${path}`;
    }
  }

  // Collection page overrides
  if (COLLECTION_PAGE_CANONICALS[path]) {
    canonical = `${baseURL}${COLLECTION_PAGE_CANONICALS[path] as string}`;
  }

  return canonical;
};
